(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rsm-bbs-finish-strip"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/bbs-"]')).forEach(function (link) {
      if (link.closest('.rsm-bbs-strip') || link.closest('.rsm-bbs-palette') || link.closest('.rsm-bbs-gallery')) return;
      var card = link.closest('.card-wrapper');
      if (!card) return;
      card.classList.add('rsm-bbs-listing-card-white');
    });

    var handle = window.location.pathname.split('/').filter(Boolean).pop();
    var rt88Finishes = [
      {
        name: 'Gold',
        slug: 'gold',
        swatch: 'gold',
        image: 'https://cdn.shopify.com/s/files/1/0608/0033/6039/files/BBS-RT88-gold-BMW-G8X-M3-M4.jpg?v=1790831191',
        alt: 'BBS RT88 Gold wheel on BMW G8X M3 and M4'
      },
      {
        name: 'White Gold',
        slug: 'white-gold',
        swatch: 'white-gold',
        image: 'https://cdn.shopify.com/s/files/1/0608/0033/6039/files/bbs-rt88-white-gold-front_8c937f7f-0a19-46d2-a7fd-4a598f5b9030.jpg?v=1790812219',
        alt: 'BBS RT88 White Gold wheel front view'
      },
      {
        name: 'Silver',
        slug: 'silver',
        swatch: 'silver',
        image: 'https://cdn.shopify.com/s/files/1/0608/0033/6039/files/BBS-rt88-silver-BMW-G80-m3-G82-M4.jpg?v=1790831193',
        alt: 'BBS RT88 Silver wheel on BMW G80 M3 and G82 M4'
      },
      {
        name: 'Dark Gold',
        slug: 'dark-gold',
        swatch: 'dark-gold',
        image: 'https://cdn.shopify.com/s/files/1/0608/0033/6039/files/BBS-RT88-midnight-gold.jpg?v=1790831194',
        alt: 'BBS RT88 Dark Gold forged wheel'
      },
      {
        name: 'Satin Black',
        slug: 'satin-black',
        swatch: 'black',
        image: 'https://cdn.shopify.com/s/files/1/0608/0033/6039/files/BBS-RT88-satin-black.jpg?v=1790831192',
        alt: 'BBS RT88 Satin Black forged wheel'
      }
    ];

    function addRt88FinishPicker(container) {
      if (!container || document.querySelector('.rsm-rt88-finish-picker')) return;

      var requestedFinish = new URLSearchParams(window.location.search).get('finish');
      var activeIndex = rt88Finishes.findIndex(function (finish) {
        return finish.slug === requestedFinish;
      });
      if (activeIndex < 0) activeIndex = 1;

      var activeFinish = rt88Finishes[activeIndex];
      var picker = document.createElement('div');
      picker.className = 'rsm-rt88-finish-picker';
      picker.innerHTML = '<p class="rsm-rt88-finish-picker__title">RT88 finish preview</p><div class="rsm-rt88-finish-picker__preview"><img src="' + activeFinish.image + '" alt="' + activeFinish.alt + '" width="900" height="900" loading="lazy" data-rsm-rt88-product-preview></div><div class="rsm-rt88-finish-picker__chips" aria-label="RT88 finish preview controls">' + rt88Finishes.map(function (finish, index) {
        var activeClass = index === activeIndex ? ' is-active' : '';
        var pressed = index === activeIndex ? ' aria-pressed="true"' : '';
        return '<button class="rsm-rt88-finish-picker__chip' + activeClass + '" type="button"' + pressed + ' data-rsm-rt88-finish-index="' + index + '"><span class="rsm-rt88-finish-picker__swatch rsm-rt88-finish-picker__swatch--' + finish.swatch + '"></span><span>' + finish.name + '</span></button>';
      }).join('') + '</div><input type="hidden" name="properties[RT88 finish interest]" value="' + activeFinish.name + '" data-rsm-rt88-finish-input><p class="rsm-rt88-finish-picker__note">Finish availability, final color, fitment, and ETA are confirmed with your RT88 quote.</p>';

      var target = container.matches('form') ? container.querySelector('.product-form__buttons') || container.querySelector('button[name="add"]') : null;
      if (target && target.parentNode) {
        target.parentNode.insertBefore(picker, target);
      } else {
        var detailHeading = Array.prototype.slice.call(container.querySelectorAll('h2')).filter(function (heading) {
          return heading.textContent.trim() === 'BBS Motorsport RT88';
        })[0];
        if (detailHeading && detailHeading.parentNode) {
          detailHeading.parentNode.insertBefore(picker, detailHeading);
        } else {
          container.insertBefore(picker, container.firstChild);
        }
      }

      var preview = picker.querySelector('[data-rsm-rt88-product-preview]');
      var input = picker.querySelector('[data-rsm-rt88-finish-input]');
      var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-rsm-rt88-finish-index]'));

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var finish = rt88Finishes[Number(button.getAttribute('data-rsm-rt88-finish-index'))];
          if (!finish) return;

          buttons.forEach(function (item) {
            item.classList.remove('is-active');
            item.removeAttribute('aria-pressed');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');

          if (preview) {
            preview.src = finish.image;
            preview.alt = finish.alt;
          }
          if (input) input.value = finish.name;

          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('finish', finish.slug);
          window.history.replaceState({}, '', nextUrl.toString());
        });
      });
    }

    if (window.location.pathname.indexOf('/products/bbs-') === 0) {
      var productForms = Array.prototype.slice.call(document.querySelectorAll('product-form form[action*="/cart/add"], form[action*="/cart/add"]'));
      var productForm = productForms.filter(function (form) {
        return form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]');
      })[0] || productForms[0];
      if (handle === 'bbs-rt88') {
        addRt88FinishPicker(document.querySelector('[id^="ProductInfo-"]') || productForm);
      }
      if (productForm && !productForm.querySelector('.rsm-bbs-product-notes')) {
        var notes = document.createElement('div');
        notes.className = 'rsm-bbs-product-notes';
        notes.innerHTML = '<label for="rsm-bbs-fitment-notes">Offset / application notes</label><textarea id="rsm-bbs-fitment-notes" name="properties[Offset / application notes]" placeholder="Desired offset, vehicle year/make/model, brake package, suspension, tire size, finish, shipping notes, or any other details we should confirm."></textarea><p>BBS Motorsport wheels are special-order and typically built to order. We will confirm fitment, offset, finish availability, pricing, and ETA before finalizing your order.</p>';
        var target = productForm.querySelector('.product-form__buttons') || productForm.querySelector('button[name="add"]');
        if (target && target.parentNode) {
          target.parentNode.insertBefore(notes, target);
        } else {
          productForm.appendChild(notes);
        }
      }
    }

    var handles = ['bbs-e07-19', 'bbs-e88-19', 'bbs-e87', 'bbs-e50'];
    if (handles.indexOf(handle) === -1) return;
    Array.prototype.slice.call(document.querySelectorAll('main details')).forEach(function (detail) {
      detail.setAttribute('open', '');
    });
    Array.prototype.slice.call(document.querySelectorAll('small')).forEach(function (note) {
      if (note.textContent.trim().toLowerCase() !== 'images courtesy of bbs motorsport.') return;
      var wrapper = note.closest('p');
      if (wrapper) wrapper.remove();
    });
    Array.prototype.slice.call(document.querySelectorAll('h3')).forEach(function (heading) {
      if (heading.textContent.trim() !== 'BBS Motorsport Finish Palette') return;
      var grid = heading.parentElement && heading.parentElement.querySelector('div[style*="display:grid"]');
      if (!grid || grid.querySelector('.rsm-bbs-product-white-gold-card')) return;
      var card = document.createElement('div');
      card.className = 'rsm-bbs-product-white-gold-card';
      card.setAttribute('style', 'display:grid;place-items:center;align-content:center;justify-content:center;justify-items:center;gap:8px;min-height:112px;padding:12px;border:1px solid rgba(18,18,18,.12);border-radius:8px;background:#fff;text-align:center;');
      card.innerHTML = '<span style="width:30px;height:30px;border-radius:50%;background:#efe7d2;border:1px solid #b6ab90;display:inline-block;"></span><strong style="font-size:13px;">White Gold request</strong><small style="display:block;color:rgba(18,18,18,.68);line-height:1.35;">BBS special color. Request availability with your quote.</small>';
      grid.appendChild(card);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
